import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import styled from 'styled-components';

import { RouteDirection } from '../../enums';
import { Event } from '../../interfaces';

import { colors } from '.';
// TODO: to be replaced by routeBadge
interface Props {
  event: Event | Partial<Event>;
}
export function EventAvatar(props: Props) {
  const { event } = props;
  if (!event) {
    return null;
  }

  const backgroundColor = colors[event.route_id % colors.length] || colors[7];
  const route = event.route_name || '-';

  let direction = '';
  const directionName = event.metadata?.route_metadata?.route_direction;

  switch (directionName ?? '') {
    case RouteDirection.NB:
      direction = '↑';
      break;

    case RouteDirection.SB:
      direction = '↓';
      break;

    case RouteDirection.EB:
      direction = '→';
      break;

    case RouteDirection.WB:
      direction = '←';
      break;
  }

  let initials = '';

  // if its a short name, display it.
  if (route.length <= 3) {
    initials = route;
  } else {
    const words = route.split(' ');
    if (words.length > 1) {
      // if its two or more words, get initials:
      for (let i = 0; i < 3 && i < words.length; i++) {
        initials += words[i].charAt(0).toUpperCase();
      }
    } else {
      // if its one long word
      initials = route.substring(0, 3);
    }
  }

  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id="t">{event.route_name ? [event.route_name, directionName].join(' ') : 'No route assigned'}</Tooltip>}
    >
      <Avatar style={{ backgroundColor }}>
        {initials}
        {direction}
      </Avatar>
    </OverlayTrigger>
  );
}

const Avatar = styled.div`
  width: 50px;
  height: 50px;
  line-height: 50px !important;

  border-radius: 100%;
  overflow: hidden;
  font-size: 0.8em;
  text-align: center;
  color: white;
  vertical-align: middle;
  font-weight: 800;
  display: inline-block;

  position: relative;
  top: 0;
  z-index: 1;

  box-shadow: 0 0 0px 2px inset rgba(0, 0, 0, 0.05);
`;
